import { useMutation, useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { Financials } from "../../../../../models/financials";
import FinancialsService from "../../../../../services/financials.service";
import { useAppState } from "../../../../../context/StateContext";
import { NotificationToast } from "../../../../../components/Generic/Toast/NotificationToast";

const useFinancialActions = () => {
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();

  const useGetFinancials = (setFinancials: (record: Financials) => void) => {
    return useQuery(["get.financials"], () => FinancialsService.get(currentUser?.companyId || 0), {
      onSuccess: (response) => {
        if (response && response.data) setFinancials(response.data);
      },
    });
  };

  const useUpdateFinancials = (onSuccess?: () => void) => {
    return useMutation(
      ["update.financials"],
      (record: Financials) => FinancialsService.update(currentUser?.companyId || 0, record),
      {
        onSuccess: () => {
          NotificationToast.success(translate("financialsUpdatedSuccessfully"));
          if (onSuccess) onSuccess();
        },
      }
    );
  };

  return {
    useGetFinancials,
    useUpdateFinancials,
  };
};

export default useFinancialActions;
